import {
  assignIfExists, assignProps, removeItemByCode,
} from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import actions, { datasourceTypes } from '../constants';
import {
  defaultDatasourceSetting,
  findCurrentDatasourceSetting,
  findDatasourceSetting,
  newDatasourceSettings,
  openDatasourceSettings,
  pruneDatasourceErrors,
} from './state';

const fetchDatasourceSettings = withDraft((draft, action) => {
  const item = findDatasourceSetting(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.settings[action.category].results.push(newDatasourceSettings(action, states.PENDING));
  }
});

const initialiseDatasourceSetting = withDraft((draft, action) => {
  const item = findDatasourceSetting(draft, action);
  if (!item) { draft.settings[action.category].results.push(newDatasourceSettings(action, states.SUCCESS)); }
});

const fetchDatasourceSettingsSuccess = withDraft((draft, action) => {
  let item = findDatasourceSetting(draft, action);
  if (!item) {
    item = newDatasourceSettings(action, states.PENDING);
    draft.settings[action.category].results.push(item);
  }
  assignProps(item, openDatasourceSettings(action));

  if (draft.activeDatasourceSetting.open) {
    assignProps(draft.activeDatasourceSetting, {
      ...action.result,
      type: action.result.type || datasourceTypes.INTERNAL,
    });
  }
});

const fetchDatasourceSettingsError = withDraft((draft, action) => {
  const item = findDatasourceSetting(draft, action);
  assignProps(item, { readErrors: [responseError(action)], readStatus: states.ERROR });
});

const showDatasourceSettings = withDraft((draft, action) => {
  const item = findDatasourceSetting(draft, action);
  draft.activeDatasourceSetting.open = true;
  draft.activeDatasourceSetting.category = action.category;
  draft.activeDatasourceSetting.code = action.code;
  draft.activeDatasourceSetting.title = action.title;
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.settings[action.category].results.push(newDatasourceSettings(action, states.PENDING));
  }
});

const updateDatasourceSettings = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  assignIfExists(item, action.properties);
  item.saveErrors = pruneDatasourceErrors(item.saveErrors, action);
  item.connection = null;
});

const saveDatasourceSettings = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  item.saveStatus = states.PENDING;
  item.saveErrors = [];
});

const hideDatasourceSettings = withDraft((draft, action) => {
  const item = findDatasourceSetting(draft, action);
  draft.activeDatasourceSetting = defaultDatasourceSetting();
  if (item) {
    draft.settings[action.category].results = removeItemByCode(draft.settings[action.category].results, item);
  }
});

const saveDatasourceSettingsError = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  assignIfExists(item, {
    saveStatus: states.ERROR,
    saveErrors: [responseError(action)],
  });
});

const testDatasourceSettings = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  item.connection = null;
  item.testErrors = [];
  item.testStatus = states.PENDING;
});

const testDatasourceSettingsSuccess = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  assignIfExists(item, { testStatus: states.SUCCESS, ...action.result });
});

const testDatasourceSettingsError = withDraft((draft, action) => {
  const item = findCurrentDatasourceSetting(draft, action);
  assignIfExists(item, { testStatus: states.ERROR, connection: false, testErrors: [responseError(action)] });
});

export default {
  [actions.FETCH_DATASOURCE_SETTINGS]: fetchDatasourceSettings,
  [actions.FETCH_DATASOURCE_SETTINGS_ERROR]: fetchDatasourceSettingsError,
  [actions.FETCH_DATASOURCE_SETTINGS_SUCCESS]: fetchDatasourceSettingsSuccess,
  [actions.HIDE_DATASOURCE_SETTINGS]: hideDatasourceSettings,
  [actions.INITIALISE_DATASOURCE_SETTINGS]: initialiseDatasourceSetting,
  [actions.REMOVE_DATASOURCE_SETTINGS]: hideDatasourceSettings,
  [actions.SAVE_DATASOURCE_SETTINGS]: saveDatasourceSettings,
  [actions.SAVE_DATASOURCE_SETTINGS_ERROR]: saveDatasourceSettingsError,
  [actions.SAVE_DATASOURCE_SETTINGS_SUCCESS]: hideDatasourceSettings,
  [actions.SAVE_DATASOURCE_WIZARD_SUCCESS]: hideDatasourceSettings,
  [actions.SHOW_DATASOURCE_SETTINGS]: showDatasourceSettings,
  [actions.TEST_DATASOURCE_SETTINGS]: testDatasourceSettings,
  [actions.TEST_DATASOURCE_SETTINGS_ERROR]: testDatasourceSettingsError,
  [actions.TEST_DATASOURCE_SETTINGS_SUCCESS]: testDatasourceSettingsSuccess,
  [actions.UPDATE_DATASOURCE_SETTINGS]: updateDatasourceSettings,
};
